// extracted by mini-css-extract-plugin
export var content = "_76-3";
export var list = "_76-4";
export var settingsContent = "_76-7";
export var settingsPanel = "_76-8";
export var state = "_76-6";
export var triggerBadge = "_76-2";
export var triggerButton = "_76-1";
export var triggerShell = "_76-0";
export var unreadDot = "_76-5";